import React from 'react'
import { useLanguage } from '../i18n/LanguageContext'

export default function Footer() {
  const { footer } = useLanguage().content.ui;

  return (
    <div className="mt-10 bg-gradient-to-r from-primary to-primaryLight px-20 py-6 text-center">
        <p className="text-lg text-white font-semibold mb-3">
            {footer.contactUs}
        </p>
        <div className="mt-2 space-x-6 flex justify-center">
            <a href="https://t.me/+x0YcI4hRFw41Mzc1" className="bg-white/20 p-2 rounded-full hover:bg-white/30 transition-colors">
                <img src="/telegram_logo.svg" alt="Telegram" className="w-8 h-8"/>
            </a>
            <a href="https://www.facebook.com/profile.php?id=100063740185932" className="bg-white/20 p-2 rounded-full hover:bg-white/30 transition-colors">
                <img src="/facebook_logo.svg" alt="Facebook" className="w-8 h-8"/>
            </a>
            <a href="https://chat.whatsapp.com/JkCZ3RLb0tB7l7de0XYZ0e" className="bg-white/20 p-2 rounded-full hover:bg-white/30 transition-colors">
                <img src="/whatsapp_logo.svg" alt="WhatsApp" className="w-8 h-8"/>
            </a>
        </div>
        <p className="text-sm text-white/70 mt-4">{footer.copyright}</p>
    </div>
  )
}
